// extracted by mini-css-extract-plugin
export default {"downloadButton":"I6eu27Qv"};